const Title = ({title, player}) => (
    <div className="flex font-inter text-[14px] text-[#0F1A24] items-center">
      {title ? (<> <span className=" font-bold">{title}</span> <div className="w-[1px] h-[30px] bg-[#A9B6C2] mx-2"></div></>): ''}
      <span className="font-[400]">{player}</span>
    </div>
  )

  export default Title;